<script lang="ts">
  import clsx from 'clsx'
  import { createEventDispatcher } from 'svelte'

  import ChevronIcon from '../../icons/ChevronIcon.svelte'

  export let hidden = false
  export let label = 'Back'
  const dispatch = createEventDispatcher()

  function onClick() {
    dispatch('click')
  }
</script>

<li class="pl-3 w-full">
  <button
    class={clsx(
      'flex items-center justify-start w-full',
      hidden ? 'hidden' : 'flex',
    )}
    on:click|preventDefault|stopPropagation={(e) => onClick()}
  >
    <span class="rotate-180"><ChevronIcon /></span>
    {label}
  </button>
</li>
